import React from "react";
import { Link } from "react-router-dom";
import MNTLogo from "../../Assets/Images/mnt-logo.png";

const HomeFooter = ({ setMainTab }) => {
  return (
    <footer className="home-footer">
      <div className="footer-content">
        <div className="footer-section">
          <img src={MNTLogo} alt="MNT Podsused logo" />
          <h3>MNT PODSUSED</h3>
          <p>Malonogometni turnir Podsused</p>
        </div>

        <div className="footer-links">
          <Link to="/kako-do-nas">Kako do nas?</Link>
          <Link to="/pravila-turnira">Pravila turnira</Link>
          <Link to="/politika-privatnosti">Politika privatnosti</Link>
          <Link to="/uvjeti-korištenja">Uvjeti korištenja</Link>
        </div>

        <div className="footer-social">
          <a
            href="https://www.instagram.com/mntpodsused/"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fi fi-brands-instagram"></i>
          </a>
          <a
            href="https://www.facebook.com/people/MNT-Podsused/61591314481188/"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fi fi-brands-facebook"></i>
          </a>
        </div>

        <div className="footer-bottom">
          <p>
            &copy; {new Date().getFullYear()} MNT Podsused. Web izradio Teo
            Ivanuš.
          </p>
        </div>
        <p className="footer-credits">
          Ikone:{" "}
          <a href="https://www.flaticon.com/" target="_blank" rel="noreferrer">
            Flaticon
          </a>
        </p>
      </div>
    </footer>
  );
};

export default HomeFooter;
